<template>
  <v-container class="pa-0">
    <div no-gutters class="d-flex horizontal-scrollable-card">
      <v-col
        v-for="recommendation in recommendations"
        :key="recommendation.slug"
        cols="12"
        md="8"
        lg="5"
      >
        <LegacyActivityCard :activity="recommendation" />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import LegacyActivityCard from '@/components/activity/LegacyActivityCard'

export default {
  name: 'NearbyRecommendations',
  components: {
    LegacyActivityCard,
  },
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    recommendations: [],
  }),
  mounted() {
    const url = `/api/v2/recommendations/?slug=${this.activity.slug}`
    this.$axios.get(url).then((response) => {
      this.recommendations = response.data.results
    })
  },
}
</script>
<style scoped>
.horizontal-scrollable-card {
  overflow-x: auto;
  white-space: nowrap;
}
</style>
